import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareService } from '../../../../core/services/share.service';
import { Announcement } from '../../../../core/models/announcement.model';

@Component({
  selector: 'app-share-buttons',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="share-container">
      <span class="share-label">Paylaş:</span>
      <div class="buttons">
        <a [href]="links.whatsapp" target="_blank" class="share-btn whatsapp" title="WhatsApp">
          <i class="fab fa-whatsapp"></i>
        </a>
        <a [href]="links.telegram" target="_blank" class="share-btn telegram" title="Telegram">
          <i class="fab fa-telegram-plane"></i>
        </a>
        <a [href]="links.facebook" target="_blank" class="share-btn facebook" title="Facebook">
          <i class="fab fa-facebook-f"></i>
        </a>
        <button (click)="copyLink()" class="share-btn copy" title="Linki kopyala">
          <i class="fas fa-link"></i>
        </button>
      </div>
    </div>
  `,
  styles: [`
    .share-container {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .share-label {
      font-size: 14px;
      font-weight: 600;
      color: #636e72;
    }
    .buttons {
      display: flex;
      gap: 8px;
    }
    .share-btn {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      color: white;
      font-size: 18px;
      transition: opacity 0.2s;
      border: none;
      cursor: pointer;
    }
    .share-btn:hover { opacity: 0.8; }
    .whatsapp { background: #25d366; }
    .telegram { background: #0088cc; }
    .facebook { background: #1877f2; }
    .copy { background: #636e72; }
  `]
})
export class ShareButtonsComponent {
  @Input() listing!: Announcement;
  private shareService = inject(ShareService);

  get links() {
    return this.shareService.getShareLinks(this.listing);
  }

  copyLink() {
    this.shareService.copyLink();
  }
}
